import ProfileUsersIcon from '../../../../../../../public/icons/profile-user.svg';

import styles from './index.module.scss';

export const UsersCompare = () => (
  <div className={styles.host}>
    <ProfileUsersIcon className={styles.icon} />
    <aside>
      <p className={styles.title}>
        Users with goals similar to yours lose weight fastest with a 3-month
        plan
      </p>
      <p className={styles.description}>*According to Youth user research</p>
    </aside>
  </div>
);
